
(function() {
  var result = { translations: { "en": null } };
  hns('I18n', result);
})();


